var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"container"},[_c(_setup.NavBarLogo),_vm._v(" "),_c(_setup.NavBarBreadcrumb),_vm._v(" "),_c('div',{staticClass:"container-last"},[_c(_setup.NavBarHelp),_vm._v(" "),_c(_setup.NavBarMenu)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }